import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';

import Button from '@ts-core/components/Button';
import RichTextField from '@ts-core/components/RichTextField';

import { usePrevious } from '@ts-core/hooks/utils';

import './styles.css';

const NewPostEditor = (props) => {
  const [content, setContent] = useState();
  const { submitting, submitError, onSubmit } = props;
  const [isFormBusy, setIsFormBusy] = useState(false);

  const prevSubmitting = usePrevious(submitting);

  useEffect(() => {
    if (prevSubmitting && !submitting && !submitError) {
      setContent('');
    }
  }, [submitting, prevSubmitting, submitError]);

  const handleSubmit = useCallback(() => {
    onSubmit({ content });
  }, [onSubmit, content]);

  return (
    <Box mt={2} width="100%">
      <RichTextField onChange={setContent} value={content} onBusyStatsChange={setIsFormBusy} />
      <Box width="100%" display="flex" justifyContent="flex-end" mt={1}>
        <Button loading={submitting} onClick={handleSubmit} disabled={!content || isFormBusy} color="primary">
          <FormattedMessage id="forum.form.submitButton" defaultMessage="Enviar" />
        </Button>
      </Box>
    </Box>
  );
};

NewPostEditor.propTypes = {
  submitting: PropTypes.bool,
  submitError: PropTypes.string,

  onSubmit: PropTypes.func,
};

NewPostEditor.defaultProps = {
  submitting: false,
  submitError: undefined,

  onSubmit() {},
};

export default NewPostEditor;
